import React, { useEffect, useState } from 'react'
import cn from 'classnames'
import { css } from '@emotion/react'
import TitleBar from './TitleBar'
import Search from './Search'
import FilterBar from './FilterBar'
import styles from './styles.less'

const searchStyle = () => theme => css`
  border-bottom: 1px solid ${theme.color.monochrome.medium};
`

export default function ConversationListHeader(props) {
  const {
    currentPart: { operator } = {},
    suggestions: { label } = {},
    SearchComponent = Search,
    TitleBarComponent = TitleBar,
    FilterBarComponent = FilterBar,
  } = props
  const defaultSize = operator === 'tag' ? 20 : 5
  const [
    previousLabelSuggestionSize,
    setPreviousLabelSuggestionSize,
  ] = useState(defaultSize)

  useEffect(
    () => {
      const previousLabelSuggestions = label
      const first = previousLabelSuggestions && previousLabelSuggestions[0]
      if (previousLabelSuggestions && (!first || !first.isLoading)) {
        const newSizeSuggestion = previousLabelSuggestions.length || defaultSize
        setPreviousLabelSuggestionSize(newSizeSuggestion)
      }
    },
    [label, defaultSize, setPreviousLabelSuggestionSize]
  )

  return (
    <div
      className={cn(
        styles['conversation-list-header'],
        'conversation-list-header'
      )}
    >
      {SearchComponent && (
        <SearchComponent
          css={searchStyle}
          previousLabelSuggestionSize={previousLabelSuggestionSize}
        />
      )}
      <TitleBarComponent />
      <FilterBarComponent />
    </div>
  )
}
